/**
 * Single source of truth for Anderson College's social profile URLs.
 *
 * Why
 *   The site footer, the homepage `sameAs` on the master
 *   EducationalOrganization, and every campus `sameAs` on the
 *   LocalBusiness-style CollegeOrUniversity schema historically each
 *   maintained their own list. They drifted (different TikTok/X
 *   handles, different Instagram usernames) and Google's Rich Results
 *   Test flagged conflicts. Per 2026-02 structured-data cleanup the
 *   footer is the authoritative list; everything else imports it.
 *
 * Rule
 *   • Edit this file ONLY when a social handle actually changes.
 *   • Order matches the footer render order.
 *   • `label` is used by the footer for `aria-label`; the schema
 *     consumers only care about `href`.
 */
export const SOCIAL_PROFILES = [
  { href: "https://www.facebook.com/andersoncollege",                                       label: "Facebook" },
  { href: "https://x.com/Anderson_Cllge",                                                   label: "X" },
  { href: "https://www.linkedin.com/school/anderson-college-of-health-business-technology/", label: "LinkedIn" },
  { href: "https://www.instagram.com/anderson.college/",                                    label: "Instagram" },
  { href: "https://www.tiktok.com/@anderson.college",                                       label: "TikTok" },
  { href: "https://www.youtube.com/channel/UCcwh-VsFWeLQz1e9vwljUyA",                       label: "YouTube" },
];

// Convenience: just the URLs for schema `sameAs` arrays.
export const SOCIAL_URLS = SOCIAL_PROFILES.map((p) => p.href);
